import { render, staticRenderFns } from "./TimeBlockBuilder.vue?vue&type=template&id=538c36fa&scoped=true"
import script from "./TimeBlockBuilder.vue?vue&type=script&lang=js"
export * from "./TimeBlockBuilder.vue?vue&type=script&lang=js"
import style0 from "./TimeBlockBuilder.vue?vue&type=style&index=0&id=538c36fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c36fa",
  null
  
)

export default component.exports